//
//
//
//
//
//
//
//

export default {
  name: 'mt-fixed-button',
    methods: {
        handleClick(evt) {
            this.$emit('click', evt);
        }
    },
  props: {
    position: {
      type: String,
      default: 'bottom-right'
    },
      type: {
          type: String,
          default: 'primary'
      },
    size: String,
    borderradius: String,
    color: String,
    background: String,
    width: String,
    height: String,
    left: String,
    right: String,
    top: String,
    bottom: String,
    contentmargintop: String
  },
    computed: {
        computeStyle: function() {
            let left = this.left;
            let right = this.right;
            let top = this.top;
            let bottom = this.bottom;
            let color = this.color;
            let background = this.background;
            let width = this.width;
            let height = this.height;
            let borderRadius = this.borderradius;
            let size = this.size;
            let _style = '';
            if (left) {
                _style += 'left:' + left + ';';
            }
            if (right) {
                _style += 'right:' + right + ';';
            }
            if (top) {
                _style += 'top:' + top + ';';
            }
            if (bottom) {
                _style += 'bottom:' + bottom + ';';
            }

            if (color) {
                _style += 'color:' + color + ';';
            }
            if (background) {
                _style += 'background:' + background + ';';
            }
            if (width) {
                _style += 'width:' + width + ';';
            }
            if (height) {
                _style += 'height:' + height + ';';
            }
            if (borderRadius) {
                _style += 'border-radius:' + borderRadius + ';';
            }
            if (size) {
                _style += 'font-size:' + size + ';';
            }
            return _style;
        },
        computeContentStyle: function() {
            let _style = '';
            let contentMarginTop = this.contentmargintop;
            if (contentMarginTop) {
                _style += 'margin-top:' + contentMarginTop + ';';
            }
            return _style;
        }
    }
};



// WEBPACK FOOTER //
// ./packages/fixed-button/src/fixed-button.vue